module.exports = __webpack_public_path__ + "static/sf-partner-softbinator-6ffa4c14a8c3106efc690c9b2df22144.jpg";